<template>
    <component :is="type" v-model="value" :errors="errors" />
</template>

<script>
import QuestionMultipleChoiceOptions from '@/components/Quiz/QuestionMultipleChoiceOptions.vue';
import QuestionShortAnswerOptions from '@/components/Quiz/QuestionShortAnswerOptions.vue';
import QuestionTrueFalseOptions from '@/components/Quiz/QuestionTrueFalseOptions.vue';
import QuestionOrderPhraseOptions from '@/components/Quiz/QuestionOrderPhraseOptions.vue';
import QuestionOrderElementsOptions from '@/components/Quiz/QuestionOrderElementsOptions.vue';
import QuestionMathFractionOptions from '@/components/Quiz/QuestionMathFractionOptions.vue';
import QuestionMathNumberWithToleranceOptions from '@/components/Quiz/QuestionMathNumberWithToleranceOptions.vue';
import QuestionMultipleAnswerOptions from '@/components/Quiz/QuestionMultipleAnswerOptions.vue';
import QuestionMathXyzAnswersOptions from '@/components/Quiz/QuestionMathXyzAnswersOptions.vue';
import QuestionMathMultipleMagnitudesOptions from '@/components/Quiz/QuestionMathMultipleMagnitudesOptions.vue';
import QuestionMathPrimeFactorsOptions from '@/components/Quiz/QuestionMathPrimeFactorsOptions.vue';
import QuestionMathPolynomialOperationOptions from '@/components/Quiz/QuestionMathPolynomialOperationOptions.vue';
import QuestionMathLatexAnswerOptions from '@/components/Quiz/QuestionMathLatexAnswerOptions.vue';
// { quiz_specific_options_import }

export default {
    name: 'QuizSpecificOptionsForm',
    components: {
        'multiple-choice': QuestionMultipleChoiceOptions,
        'short-answer': QuestionShortAnswerOptions,
        'true-false': QuestionTrueFalseOptions,
        'order-phrase': QuestionOrderPhraseOptions,
        'order-elements': QuestionOrderElementsOptions,
        'math-fraction': QuestionMathFractionOptions,
        'math-number-with-tolerance': QuestionMathNumberWithToleranceOptions,
        'multiple-answer': QuestionMultipleAnswerOptions,
        'math-xyz-answers': QuestionMathXyzAnswersOptions,
        'math-multiple-magnitudes': QuestionMathMultipleMagnitudesOptions,
        'math-prime-factors': QuestionMathPrimeFactorsOptions,
        'math-polynomial-operation': QuestionMathPolynomialOperationOptions,
        'math-latex-answer': QuestionMathLatexAnswerOptions,
        // { quiz_specific_options_component }
    },
};
</script>
<script setup>
import { useVModel } from '@vueuse/core';

let emit = defineEmits(['update:modelValue']);
const props = defineProps({
    modelValue: {
        required: true,
    },
    errors: {
        required: true,
    },
    type: {
        required: true,
        type: String,
    },
});

const value = useVModel(props, 'modelValue', emit);
</script>
